import { TableCell, TableRow } from "@shadcn-in-nx/ui/table";
import { Button } from "@shadcn-in-nx/ui/button";
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
} from "@shadcn-in-nx/ui/alert-dialog";
import { Trash2, UserPlus } from "lucide-react";
import { useTranslation } from "react-i18next";
import DialogManageMembers from "./DialogManageMembers";

export const GroupRow = ({ group, actAsAdmin, onChange, deletingGroupId, onDelete }) => {
    const { t } = useTranslation();

    return (
        <TableRow>
            <TableCell>
                <div className="flex items-center gap-2">
                    <div
                        className="w-3 h-3 rounded-full"
                        style={{ backgroundColor: group.color }}
                    />
                    <span className="font-medium">{group.name}</span>
                </div>
            </TableCell>
            <TableCell>
                <span className="text-gray-600">
                    {group.description || t("groups.noDescription")}
                </span>
            </TableCell>
            <TableCell>
                <span className="text-sm bg-gray-100 px-2 py-1 rounded">
                    {t("groups.memberCount", { count: group.memberCount || 0 })}
                </span>
            </TableCell>
            <TableCell>
                {new Date(group.createdAt).toLocaleDateString()}
            </TableCell>
            <TableCell>
                <div className="flex items-center gap-2">
                    <DialogManageMembers
                        group={group}
                        actAsAdmin={actAsAdmin}
                        onChange={onChange}
                        trigger={
                            <Button
                                variant="ghost"
                                size="sm"
                                className="text-blue-600 hover:text-blue-700 hover:bg-blue-50"
                            >
                                <UserPlus className="w-4 h-4" />
                            </Button>
                        }
                    />
                    <AlertDialog>
                        <AlertDialogTrigger asChild>
                            <Button
                                variant="ghost"
                                size="sm"
                                className="text-red-600 hover:text-red-700 hover:bg-red-50"
                                disabled={deletingGroupId === group.id}
                            >
                                <Trash2 className="w-4 h-4" />
                            </Button>
                        </AlertDialogTrigger>
                        <AlertDialogContent>
                            <AlertDialogHeader>
                                <AlertDialogTitle>
                                    {t("groups.deleteGroup")}
                                </AlertDialogTitle>
                                <AlertDialogDescription>
                                    {t("groups.deleteGroupDescription", {
                                        name: group.name,
                                    })}
                                </AlertDialogDescription>
                            </AlertDialogHeader>
                            <AlertDialogFooter>
                                <AlertDialogCancel>
                                    {t("groups.cancel")}
                                </AlertDialogCancel>
                                <AlertDialogAction
                                    onClick={() => onDelete(group.id)}
                                    className="bg-red-600 hover:bg-red-700"
                                >
                                    {t("groups.deleteGroup")}
                                </AlertDialogAction>
                            </AlertDialogFooter>
                        </AlertDialogContent>
                    </AlertDialog>
                </div>
            </TableCell>
        </TableRow>
    );
};

export default GroupRow;
